import { Pipe, PipeTransform, inject } from '@angular/core';
import { SessionService } from '../services/session.service';
import { formatDateInTimeZone } from '../shared/date-time.util';


@Pipe({
    name: 'dateMoment',
    standalone: true
})
export class DateMomentPipe implements PipeTransform {
  private _sessionSrv = inject(SessionService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  public transform(value: unknown, args?: ReadonlyArray<{ timezone?: string; format?: string; locale?: string }>): string {
    if (!value) {
      return '';
    }

    const { timezone, format, locale } = args?.[0] ?? {};
    return formatDateInTimeZone(
      value,
      format ?? 'L',
      timezone ?? this._sessionSrv.getTimezone,
      locale ?? this._sessionSrv.getLanguage,
    );
  }
}
